import { Switch } from "@msuite/ui/form";
import { useDataTableContext } from "@msuite/ui/table";
import { uniqueArray } from "@msuite/utils/array";
import type { SubstitutionPlanFrontendFormSchema } from "@msuite/utils/schemas";
import { useFormContext, useWatch } from "react-hook-form";
import { useSubstitutionPlanFormContext } from "./context";

/** Props Interface */
interface SubstitutionPlanIsRequiredHandlerProps {
	itemId: string;
}

export function SubstitutionPlanIsRequiredHandler({
	itemId,
}: SubstitutionPlanIsRequiredHandlerProps) {
	const { getSelectedRowIds, table } = useDataTableContext();
	const { getItemIndex } = useSubstitutionPlanFormContext();
	const index = getItemIndex(itemId);
	const methods = useFormContext<SubstitutionPlanFrontendFormSchema>();

	/** Values */
	const isChecked = useWatch({
		control: methods.control,
		name: `items.${index}.isAssignmentNotRequired`,
	});

	/** Functions */
	function handleOnCheckedChange(checked: boolean) {
		const ids = uniqueArray([itemId].concat(getSelectedRowIds()));
		for (const id of ids) {
			const index = getItemIndex(id);
			const path = `items.${index}.isAssignmentNotRequired` as const;
			methods.setValue(path, checked);
			table.resetRowSelection();
		}
	}

	/** Render */
	return (
		<div className="h-stack justify-end w-full px-3">
			<Switch
				checked={isChecked}
				onCheckedChange={handleOnCheckedChange}
			/>
		</div>
	);
}
